import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { useCurrentTheme } from 'src/editor/layout/sidebar/website-styles-settings/hooks/useCurrentTheme'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { buttonAndFormFieldColorKeyMap } from 'src/editor/store/website-settings/website-settings-selector'
import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteButtonStyleEnum,
  WebsiteButtonsInterface,
  WebsiteFormFieldsSettings,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { BorderRadiusControl } from '../../controls/border-radius-control'
import { PaddingGroup } from '../padding'

type WebsiteStyles = WebsiteButtonsInterface & WebsiteFormFieldsSettings
interface ButtonAndFormFieldStyleGroupProps {
  updateWebsiteStyles: <Key extends keyof WebsiteStyles>(
    prop: Key,
  ) => (value: WebsiteStyles[Key]) => void
  styleSettings: WebsiteButtonsInterface | WebsiteFormFieldsSettings
  type: WebsiteButtonAndFormFieldTypes
}

export const ButtonAndFormFieldStyleGroup = ({
  updateWebsiteStyles,
  styleSettings,
  type,
}: ButtonAndFormFieldStyleGroupProps) => {
  const { currentTheme, onUpdate } = useCurrentTheme()

  const updateStyle = (value: WebsiteButtonStyleEnum) => {
    if (styleSettings?.style === value) {
      return
    }
    const borderColorKey = buttonAndFormFieldColorKeyMap[type].borderColor
    const backgroundColorKey =
      buttonAndFormFieldColorKeyMap[type].backgroundColor
    const textColorKey = buttonAndFormFieldColorKeyMap[type].textColor

    const isFormField = type === WebsiteSettingsTypographyTypeEnum.FormField

    if (isFormField) {
      const textColor =
        currentTheme.formFields[
          textColorKey as keyof typeof currentTheme.formFields
        ]
      const backgroundColor =
        currentTheme.formFields[
          backgroundColorKey as keyof typeof currentTheme.formFields
        ]
      const borderColor =
        currentTheme.formFields[
          borderColorKey as keyof typeof currentTheme.formFields
        ]

      onUpdate({
        formFields: {
          ...currentTheme.formFields,
          [backgroundColorKey]: borderColor || textColor,
          [borderColorKey]: backgroundColor,
          [textColorKey]: backgroundColor,
        },
      })
    } else {
      const buttonTextColor =
        currentTheme.buttons[textColorKey as keyof typeof currentTheme.buttons]
      const backgroundColor =
        currentTheme.buttons[
          backgroundColorKey as keyof typeof currentTheme.buttons
        ]
      const borderColor =
        currentTheme.buttons[
          borderColorKey as keyof typeof currentTheme.buttons
        ]

      onUpdate({
        buttons: {
          ...currentTheme.buttons,
          [backgroundColorKey]: borderColor || buttonTextColor,
          [borderColorKey]: backgroundColor,
          [textColorKey]: backgroundColor,
        },
      })
    }

    return updateWebsiteStyles('style')(value)
  }
  return (
    <OptionWrapper
      labelClassName="mb-0.5"
      labelText="website_styles_settings.buttons_and_links.style.title"
    >
      {/* TODO decided to temporarily remove */}
      {/* <Switcher
        btnList={[
          {
            value: WebsiteButtonStyleEnum.Filled,
            content: 'website_styles_settings.buttons_and_links.style.filled',
          },
          {
            value: WebsiteButtonStyleEnum.Outlined,
            content: 'website_styles_settings.buttons_and_links.style.outlined',
          },
        ]}
        update={updateStyle}
        value={
          (styleSettings?.style as WebsiteButtonStyleEnum) ||
          WebsiteButtonStyleEnum.Filled
        }
        className="p-0"
        btnClassName="flex justify-center items-center h-10 [&>svg]:w-5 [&>svg]:h-5"
      /> */}
      <div className="flex gap-3">
        <PaddingGroup
          padding={styleSettings.padding}
          update={updateWebsiteStyles('padding')}
          label=""
          withoutExpandButton
        />
        <BorderRadiusControl
          label=""
          border={styleSettings.border}
          update={updateWebsiteStyles('border')}
          withoutExpandButton
          wrapperClassName="last-of-type:mb-0"
        />
      </div>
    </OptionWrapper>
  )
}
